<template>
  <div>
    <div class="fp-top-row">
      <div class="ed-itemTabs clr" v-if="item.fair_ids">
        <template v-for="(eventId, index) in item.fair_ids">
          <div :key="index">
            <template v-if="eventLookup[eventId]">
              <div v-if="isSpecificEvent(eventId)" style="margin-top: 32px"></div>
              <Flag v-else :event-id="Number.parseInt(eventId)" :event-lookup="eventLookup" />
            </template>
          </div>
        </template>
      </div>

      <template v-if="item.portrait_url">
        <div class="ed-grid__item live-icon">
          <template v-if="streamAgendaUtility.isLive">
            <img
              alt="Live Symbol"
              class="fp-live-icon"
              :src="getLiveIconUrl"/>
          </template>

          <template v-else>
            <i class="icon icon-smart-display"></i>
          </template>
        </div>
      </template>
    </div>
    <div class="ed-grid">
      <div class="ed-grid__item ed-grid__item--1" :class="{'fp-grid__item': view_size_mode >= 2, 'fp-grid__item__mobile': view_size_mode < 2, 'full-width fp-grid__item--terminalMode': terminalmode}">
        <div class="ed-text fp-date_item" :class="{'fp-date_item__mobile': view_size_mode < 2}">
          <span class="fp-text__title fp-date_time">
            {{ getFormattedDateTime(item) }}
          </span>
          <div class="ed-text__small">{{ date }}</div>
        </div>
      </div>
      <div class="ed-grid__item ed-grid__item--2" :class="{'full-width': terminalmode}">
        <div class="ed-text">
            <span class="ed-text__small">
              {{ getFormattedOrganizerSpace(this.item) }}
            </span>
            <h3
              v-if="item.title"
              class="ed-text__title ed-text__title--link"
              aria-haspopup="true"
              :title="$t('list.linkToDetailTooltip')"
              @click="updateRoute(item)">
              {{ item.title }}
            </h3>
            <template v-if="item.av_categories || item.fp_topics">
              <span class="fp-categories_list" :class="{'ed-text__small--terminalmode': terminalmode}">
                <template v-if="item.fp_topics">
                  <div class="fp-category_filter" v-for="(topic, index) in item.fp_topics" :key="index">
                    <div class="fp-category_box" :style="{backgroundColor:  getTopicService(topic) !== '' ? getTopicService(topic) : 'black'}"></div>
                    <div class="fp-category_name">{{getTopicTitle(topic)}}</div>
                  </div>
                </template>
                <template v-if="item.av_categories">
                  <div class="fp-category_filter" v-for="(category, index) in item.av_categories" :key="`A${index}`">
                    <div class="fp-category_box"></div>
                    <div class="fp-category_name">{{ category }}</div>
                  </div>
                </template>
              </span>
            </template>
          <template v-if="item.fp_organizer">
            <div :class="{'ed-text__small--terminalmode': terminalmode}" style="padding-top: 0.5em;">{{ item.fp_organizer[0] }}</div>
          </template>
          <template v-if="contacts.length > 0">
            <div class="ed-text__small fp-contacts">
              <p>
                <template v-for="(person, index) in contacts">

                  {{ (person.title || '').trim() }}
                  {{ (person.surname || '').trim() }}
                  {{ (person.name || '').trim() }}

                  <span :key="index" v-if="person.company || person.position">
                    ({{ (person.company || '').trim() }}{{ person.company && person.position ? ', ' : '' }}
                    {{ (person.position || '').trim() }})</span><span :key="index" v-if="index + 1 < contacts.length">, </span>
                </template>
              </p>
            </div>
          </template>
          <template v-if="contacts.length === 0">
            <div class="fp-empty_contacts"></div>
          </template>
        </div>
      </div>
    </div>

    <ButtonComponent @setFavourite="setFavourite(item.id)" @updateRoute="updateRoute" :view_size_mode="view_size_mode" :show_favourite="true" :is_favourite="is_favourite" :terminalmode="terminalmode"/>
  </div>
</template>

<script>
import Flag from './Flag.vue';
import TopicService from '@/common/topic.service';
import ButtonComponent from './ButtonComponent.vue';
import {SolrFrameworkProgramTypeName} from '@/common/Utility';
import StreamAgendaUtility from '../common/StreamAgendaUtility';

export default {
  name: 'ProgramItem',
  components: {
    ButtonComponent,
    Flag,
  },
  data() {
    return {
      medizinEventId: 35076,
      cmtEventId: 34781,
      streamAgendaUtility: null,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    hallplan_path: {
      type: String,
      required: true,
    },
    eventLookup: {
      type: Object,
      required: true,
    },
    configurations: {
      type: Array,
      required: true,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    getFormattedOrganizerSpace: {
      type: Function,
      required: true,
    },
    getFormattedDateTime: {
      type: Function,
      required: true,
    },
    getContacts: {
      type: Function,
      required: true,
    },
    is_favourite: {
      type: Boolean,
      required: true,
    },
    path: {
      type: String,
      default: '',
    },
  },
  computed: {
    getCroppedText() {
      return this.$root.$options.filters.crop(this.item.content, 200, '...');
    },
    contacts() {
      return this.getContacts(this.item);
    },
    getLiveIconUrl() {
      if (this.path) {
        return `/${this.path}/typo3conf/ext/messe_exhibitordirectory_azure/src/assets/images/live-icon.png`;
      }
      return '/typo3conf/ext/messe_exhibitordirectory_azure/src/assets/images/live-icon.png';
    },
  },
  mounted() {
    if (this.item.portrait_url) {
      this.streamAgendaUtility = new StreamAgendaUtility(this.item);
      this.streamAgendaUtility.initInterval();
    }
  },
  beforeDestroy() {
    this.streamAgendaUtility.clearInterval();
  },
  methods: {
    isSpecificEvent(eventId) {
      const parsedEventId = Number.parseInt(eventId, 10);
      return parsedEventId === this.cmtEventId || parsedEventId === this.medizinEventId;
    },
    getTopicTitle(topic) {
      const parts = topic.split('|');
      if (parts.length > 1) {
        return parts[1];
      }
      return topic;
    },
    getTopicService(topic) {
      const parts = topic.split('|');
      const fairId = this.item.fair_ids[0];
      const config = this.configurations.find(c => c.fair_ids.includes(fairId));
      if (config && parts.length > 1) {
        return TopicService.getTopicColorFrom(config, parts[0], parts[1]);
      }
      return TopicService.getTopicColor(topic);
    },
    updateRoute() {
      this.$emit('updateRoute', this.item);
    },
    setFavourite(itemId) {
      this.$emit('setFavourite', itemId);
    },
  }
};
</script>

<style scoped lang="scss">
.fp-grid__item {
  padding-top: 2em;
  text-align: right;
}

.fp-grid__item--terminalMode {
  text-align: left;
}

.fp-date_time {
  font-size: 15px;
  padding-bottom: 0.3em;
}

.fp-contacts {
  margin-top: 0.2em;
}

.fp-category_filter {
  display: flex;
  flex-wrap: nowrap;

  .fp-category_name {
    margin-right: 0.7em;
    margin-bottom: 0.5em;
  }
}

.fp-categories_list {
  display: flex;
  margin-top: 1em;
  font-size: 14px;
  flex-wrap: wrap;
}

.fp-date_item {
  display: flex;
  flex-direction: column;
  padding-bottom: 0.5em;
  .ed-text__small {
    padding-bottom: 0!important;
  }
}
.ed-item {
  div.ed-grid {
    div.ed-grid__item.ed-grid__item--1 {
      &.fp-grid__item__mobile {
        border-bottom: 0;
        height: 100%;
        display: block;

      }
    }
  }
}

.fp-empty_contacts {
  margin-top: 20px;
}

.ed-text__small--terminalmode {
  line-height: 1.4;
}

.fp-top-row {
  display: flex;
  justify-content: space-between;

  .live-icon {
    position: absolute;
    right: 10px;
    top: 10px;

    .fp-live-icon {
      width: 65px;
    }

    .icon-smart-display {
      line-height: 24px;
      font-size: 24px;
    }
  }
}

</style>
